var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 5.53317C16.3487 6.58216 17.0627 7.91854 17.3519 9.37333C17.6411 10.8281 17.4924 12.336 16.9247 13.7063C16.357 15.0766 15.3957 16.2478 14.1624 17.0718C12.9291 17.8958 11.4791 18.3356 9.99585 18.3356C8.5126 18.3356 7.06265 17.8958 5.82933 17.0718C4.59602 16.2478 3.63472 15.0766 3.06699 13.7063C2.49926 12.336 2.35059 10.8281 2.63978 9.37333C2.92897 7.91854 3.64304 6.58216 4.69169 5.53317M10 1.6665V9.99984",
    stroke: "#39923A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.dc126328864ec37300243054182dc842.svg";
export { ForwardRef as ReactComponent };